import { FirebaseFunctionsError } from '../../shared/customerrors';
class ConnectionsCtrl {
  constructor($window, $state, $uibModal, $timeout, SchemaService, TemplateService, FEService, FormBuilderService, TokenRefreshService, FlashService, TBService, $location, AuthService, $scope) {
    'ngInject';

    Object.assign(this, { $location, $window, $state, $uibModal, $timeout, SchemaService, TemplateService, TBService, FlashService, FEService, FormBuilderService, AuthService, TokenRefreshService });

    this.connections = [];
    this.pendingDelete = [];
    this.$scope = $scope;
    this.loadingNote = 'Loading Connections...';

    this.sortKey = 'updatedAt'; // set the default sort type
    this.sortReverse = true;
    this.connectionsColumns = [];
  }

  async $onInit() {
    try {
      $('body').css('overflow-y', 'auto');
      [this.provider, this.PROVIDER, this.realm] = await Promise.all([
        this.AuthService.provider(),
        this.AuthService.getProviderSettings(),
        this.AuthService.realm(),
        this.loadRealmConns()]);
      this.formatColumnData();
      this.setColumns();
    } catch (error) {
      if (error instanceof FirebaseFunctionsError) {
        if (error.code == 'permission-denied' || error.code == 'unauthenticated') {
          this.$state.go('login', { provider: error?.details?.provider, reload: true, validationErrorMessage: error?.details?.validationErrorMessage });
          return;
        }
      }
      this.FlashService.error(error.message || error.toString());
      console.error(error);
    }

    this.loadingNote = '';
    const watchConnection = this.$scope.$watch(`$ctrl.validConnection`, (newVal, oldVal) => {
      if (newVal && newVal != oldVal) {
        this.updating = true;
        this.updateConnection()
          .then(connection => {
            if (connection) {
              const index = this.connections.findIndex(c => c.id === connection.id);
              if (index >= 0) {
                Object.assign(this.connections[index], connection);
                this.formatColumnData();
              }
            }
            this.FlashService.success("Connection updated successfully!");
            this.modal.close();
          })
          .catch(error => {
            this.updating = false;
            this.FlashService.error(error.message || 'Failed to update connection');
            console.error(error);
          });
      }
    });
    this.$scope.$on('$destroy', () => { watchConnection() });
  }

  async loadRealmConns() {
    const response = await this.SchemaService.getRealmConnections({includeTemplates: true});
    const { "data": { connections, prompts } } = response;
    this.connections = connections;
    this.prompts = prompts;
    return connections;
  }

  formatColumnData() {
    this.connections.forEach(c => {
      const propertyLabel = this.TemplateService.getConnLabel(this.PROVIDER.connPropLabels, c.properties);
      const connPropsLabel = `<span class="help-block small text-muted conn-label">${propertyLabel}</span>`;
      c.formattedName = c.name + connPropsLabel;
    });
  }

  setColumns() {
    const cellStyle = {
      'text-align': 'center',
      'vertical-align': 'inherit'
    };

    this.connectionsColumns = [
      {
        'key': 'formattedName',
        'header': 'Name',
        'sortable': true,
        'tooltip': false,
        'style': { ...cellStyle },
        'onClick': (_, connection) => console.info(connection)
      }, 
      {
        'key': 'templates',
        'header': 'Templates',
        'sortable': true,
        'tooltip': false,
        'style': {...cellStyle, "max-width": "100px", "width": "100px"},
        'format': (value) => `<i class="fa fa-list text-muted"></i>&nbsp;&nbsp;${value.length}`,
        'onClick': (_, connection) => this.openTemplates(connection)
      }, 
      {
        'key': 'createdByName',
        'header': 'Owner',
        'sortable': true,
        'tooltip': true,
        'style': {...cellStyle, "max-width": "200px", "width": "200px"},
        'format': (value) => { return value }
      }, 
      {
        'key': 'updatedAt',
        'header': 'Updated',
        'sortable': true,
        'style': { ...cellStyle, "max-width": "98px", "width": "98px" },
        'format': (value) =>
          `<span>${value ? new Date(value).toLocaleDateString("en-US") : ''}</span>`
      },
      {
        'key': 'id',
        'header': 'Update',
        'style': { ...cellStyle, "max-width": "60px", "width": "60px" },
        'format': _ => `<i class="fa fa-pencil-square-o text-muted"></i>`,
        'onClick': (_, connection) => this.showUpdateConnection(connection)
      }, 
      {
        'key': 'id',
        'header': 'Delete',
        'style': { ...cellStyle, "max-width": "60px", "width": "60px" },
        'format': (_a, _b, conn) => conn.isOwner ? `<i class="fa fa-trash text-muted"></i>` : '',
        'onClick': (_, connection) => this.deleteConnection(connection)
      }
    ];

    this.templatesColumns = [
      {
        'key': 'title',
        'header': 'Title',
        'onClick': (_, template) => this.openTemplate(template)
      }, 
      {
        'key': 'id',
        'header': 'Open',
        'style': { ...cellStyle, "max-width": "60px", "width": "60px" },
        'format': () => `<i class="fa fa-external-link text-muted"></i>`,
        'onClick': (_, template) => this.openTemplate(template)
      }
    ];
  }

  openTemplates(connection) {
    if (!connection.templates.length) {
      this.FlashService.error("No templates are associated to this connection!");
      return;
    }
    this.modal?.close();
    this.selectedTemplates = connection.templates;

    this.modal = this.$uibModal.open({
      backdrop: 'static',
      template: `
      <div class="modal-header">
        <h3 class="modal-title">Associated Templates</h3>
      </div>
      <div class="modal-body">
        <record-list 
          columns="$ctrl.templatesColumns" 
          caption="'Template List'"
          records="$ctrl.selectedTemplates"
          page-size="10"
          search="true"
        >
        </record-list>
      </div>
      <div class="modal-footer">
        <div class="btn-group btn-group-justified" role="group" aria-label="...">
          <div class="btn-group" role="group">
            <button type="button" class="btn btn-warning" 
              ng-click="$ctrl.closeModal()">Cancel</button>
          </div>
        </div>
      </div>`,
      scope: this.$scope,
      size: 'lg'
    });
  }

  openTemplate(template) {
    let url;
    switch(template.type) {
      case 'dynamic':
        url = this.$state.href('app.dynamic-builder', { 'templateId': template.id });
        break;
      default:
        url = this.$state.href('app.template-builder', { 'templateId': template.id });
        break;
    }
    this.$window.open(url,'_blank');
  }

  closeModal() {
    this.modal?.close();
    this.modal = null;
  }
  
  showUpdateConnection(connection) {
    this.modal?.close();
    this.validConnection = false;
    this.updating = false;
    this.activeConnection = connection;
    this.newPrompts = undefined;
    this.prompts.forEach(p => { if (!p.encrypted) p.response = connection[p.key]; } );
    this.template = { provider: this.provider, realm: this.realm, connectionId: this.activeConnection.id };
    console.info(this.activeConnection.id);
    this.modal = this.$uibModal.open({
      backdrop: 'static',
      template: `
      <div class="modal-header">
        <button type="button" class="close" ng-click="$ctrl.closeModal()" aria-hidden="true">&times;</button>
        <h3 class="modal-title">Update Connection</h3>
      </div>
      <div class="modal-body">
        <app-manager
          class="app-manager"
          template="$ctrl.template"
          updating="$ctrl.updating"
          connection-is-valid="$ctrl.validConnection"
          ignore-stored-conn="true"
          ignore-leave-confirm="$ctrl.ignoreLeaveConfirm"
          connection-id="$ctrl.activeConnection.id"
          init-prompts="$ctrl.prompts"
          prompts="$ctrl.newPrompts"
          show-back="false"
        ></app-manager>
      </div>`,
      scope: this.$scope,
      size: 'md'
    });
  }

  async updateConnection() {
    const request = { template: this.template, promptValues: this.newPrompts, updateExistingConn: true, returnConnection: true };
    const response = await this.FEService.httpsCallable('storeTemplateConnection', request);
    return response.data.connection;
  }

  async deleteConnection(connection) {
    const connectionId = connection.id;
    const tempCount = connection.templates.length;
    if (!this.$window.confirm(`Are you sure you wish to delete connection "${connection.name}"?${tempCount ? `\nIt has ${tempCount} templates associated!`: ''}`)) { return }
    this.pendingDelete.push(this.connections.find(c => c.id === connectionId));
    this.connections = this.connections.filter(c => c.id !== connectionId);

    try {

      const { data } = await this.SchemaService.deleteUserConnection(connectionId);
      
      if (data.connectionId === connectionId) {
        this.FlashService.success(`Connection "${connection.name}" was deleted successfully!`);
      } else {
        data.errorMessages.map(e => this.FlashService.error(e));
        this.connections.push(this.pendingDelete.find(c => c.id === connectionId));
      }
    } catch (error) {
      this.FlashService.error('There was an error deleting the connection');
      console.error(error);
      this.connections.push(this.pendingDelete.find(c => c.id === connectionId));
    }
    this.pendingDelete = this.pendingDelete.filter(c => c.id !== connectionId);
  }
}

export default {
  bindings: {},
  templateUrl: "user/connections/connections.component.html",
  controller: ConnectionsCtrl
};
